import { DetailHeader } from "../../components/detailHeader/DetailHeader";
import { Box, Grid, Typography } from "@mui/material";
import { RecordContext } from "../../components/record/Record";
import { useContext } from "react";
import { Avatar } from "../../components/fieldsViews/fields/Avatar";
import { format } from "date-fns";
import { pt } from "date-fns/locale";
import { calculateEvaluationAverage } from "./utils";

export const StaffKpisDetailHeader = () => {
    const recordContext = useContext(RecordContext);

    if (!recordContext) return null;
    const { user, month, teamwork, client_relationship, autonomy, critical_thinking } = recordContext.item;

    const average = calculateEvaluationAverage(teamwork, client_relationship, autonomy, critical_thinking);
    
    return (
        <DetailHeader collection={recordContext.collection}>
            <Typography variant="h6" color="secondary">
                Avaliação de desempenho
            </Typography>
            <Grid container alignItems="flex-start" display="flex" flexWrap="nowrap" flexDirection="row" gap={5}>
                <Grid item xs={12}>
                    <Typography variant="h6" color="primary">
                        Colaborador
                    </Typography>
                    <Box display="flex" alignItems="center" columnGap={4}>
                        <Avatar value={user?.avatar} styles={{ width: 25, height: 25 }} />
                        {user?.first_name && (
                            <Typography variant="body1">
                                {user?.first_name} {user?.last_name}{" "}
                            </Typography>
                        )}
                    </Box>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="h6" color="primary">
                        Mês:
                    </Typography>
                    <Typography variant="h6">{format(new Date(month), "MMMM yyyy", { locale: pt })}</Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="h6" color="primary">
                        Média:
                    </Typography>
                    <Typography variant="h6">{average}</Typography>
                </Grid>
            </Grid>
        </DetailHeader>
    );
};
